/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Twda_Status_SkippedInputs */



/**
* | output |
* | --- |
* | "Winner's deck not sent to the TWDA: {reason}." |
*
* @param {Twda_Status_SkippedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_status_skipped = /** @type {((inputs: Twda_Status_SkippedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Status_SkippedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Deck du vainqueur non soumis au TWDA : ${i?.reason}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Mazo del ganador no enviado al TWDA: ${i?.reason}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Deck do vencedor não enviado para o TWDA: ${i?.reason}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Mazzo del vincitore non inviato al TWDA: ${i?.reason}.`)
	return /** @type {LocalizedString} */ (`Winner's deck not sent to the TWDA: ${i?.reason}.`)
});